import { useContext } from 'react';

import { ImportConfigurationContext } from './import-configuration-context';

export const useImportConfiguration = () => {
  const context = useContext(ImportConfigurationContext);

  if (context === undefined) {
    throw new Error(
      'useImportConfiguration must be used within an ImportConfigurationProvider',
    );
  }

  return context;
};
